import awsRegions from "../aws/regions";

import styles from "./Styles.module.scss";
import { AzureIcon, GcpIcon, AwsIcon, AwsCircleIcon, AzureCircleIcon, GcpCircleIcon, OnpremCircleIcon, OnpremIcon } from "@netapp/bxp-design-system-react/icons/custom";

const allRegions = {
    aws: awsRegions
}

export const regionLabel = (provider, regionOrLocation) => {
    return allRegions[provider]?.[regionOrLocation] || regionOrLocation;
}

export const providersMap = {
    aws: { label: "AWS", longLabel: "Amazon Web Services", icon: AwsIcon, circleIcon: AwsCircleIcon, tableIconClassName: styles['aws-icon'] },
    azure: { label: "Azure", longLabel: "Microsoft Azure", icon: AzureIcon, circleIcon: AzureCircleIcon, tableIconClassName: styles['azure-icon'] },
    gcp: { label: "Google Cloud", longLabel: "Google Cloud Platform", icon: GcpIcon, circleIcon: GcpCircleIcon, tableIconClassName: styles['gcp-icon'] },
    "on-prem": { label: "On-Premises", longLabel: "On-Premises", icon: OnpremIcon, circleIcon: OnpremCircleIcon, tableIconClassName: styles['on-prem-icon'] },
    oci: { label: "OCI", longLabel: "OCI", icon: OnpremIcon, circleIcon: OnpremCircleIcon, tableIconClassName: styles['on-prem-icon'] }
};

export const providerAddWEURLPath = (provider, featuresByKey, isHa, params) => {
    const cvoAwsKey = "NetApp.OntapCVO/new-create-cvo-AWS"; 
    const cvoGcpKey = "NetApp.OntapCVO/new-create-cvo-GCP"; 
    const cvoAzureKey = "NetApp.OntapCVO/new-create-cvo-AZURE"; 
    const ha = isHa ? '-ha' : '';
    const isCreate = params?.createOrDiscover === 'create' || params?.createOrDiscover === 'create-ha';
    const urlPath = {
        cvo: {
            aws: '/add-new-working-environment/cvo/aws',
            gcp: '/add-new-working-environment/cvo/gcp',
            azure: '/add-new-working-environment/cvo/azure',
            angular: '/add-new-working-environment-wizard'
        }
    };
    
    if(isCreate && provider === 'aws' && featuresByKey[cvoAwsKey]?.active) {
        return urlPath.cvo.aws + ha;
    } else if (isCreate && provider === 'gcp' && featuresByKey[cvoGcpKey]?.active) {
        return urlPath.cvo.gcp + ha;
    } else if (isCreate && provider === 'azure' && featuresByKey[cvoAzureKey]?.active) {
        return urlPath.cvo.azure + ha;
    } else {
        return urlPath.cvo.angular
    }
}
